<template>
    <div class="search-condition-date-range" :value="value">
        <label for="create-date-from">{{fromText}}<span v-if="required" style="color:#FC1111;">*</span></label>
        <input type="text"
               id="create-date-from"
               name="create-date-from"
               :value="value.from" v-on:change="startDateChange"
               placeholder="请选择日期" data-date-format="yyyy/mm/dd"
               onfocus="(this.type='date')"
               onblur="(this.type='text')">
        <label for="create-date-to">{{toText}}</label>
        <input type="text"
               id="create-date-to"
               name="create-date-to"
               :value="value.to" v-on:change="endDateChange"
               placeholder="请选择日期" data-date-format="yyyy/mm/dd"
               onfocus="(this.type='date')"
               onblur="(this.type='text')">
    </div>
</template>

<script>
    export default {
        name: "BInputDateRange",
        props: {
            fromText: String,
            toText: String,
            required: Boolean,
            value: {
                from: String,
                to: String
            },
        },
        methods: {
            startDateChange(event) {
                if (event.target.value !== undefined) {
                    this.$emit("startDateChange", event.target.value);
                } else {
                    this.$emit("startDateChange", '');
                }
            },
            endDateChange(event) {
                if (event.target.value !== undefined) {
                    this.$emit("endDateChange", event.target.value);
                } else {
                    this.$emit("endDateChange", '');
                }
            }
        }
    }
</script>

<style scoped>
    .search-condition-date-range {
        display: flex;
        align-items: center;
    }

    .search-condition-date-range label:nth-of-type(1) {
        color: #333333;
        width: 66px;
        text-align: right;
        font-size: 14px;
        margin: 0 10px 0 20px;
    }

    .search-condition-date-range label:nth-of-type(2) {
        color: #333333;
        text-align: right;
        margin: 0 10px 0 10px;
    }

    .search-condition-date-range input {
        width: 220px;
        height: 42px;
        background: #FFFFFF;
        border: 1px solid #DEE2E6;
        border-radius: 5px;
        color: #666666;
        padding-left: 10px;
        padding-right: 10px;
        margin: 12px 0 12px 0;
    }

    input:focus {
        border: 1px solid #0171A3;;
    }

    * {
        outline: none;
    }
</style>